import { render, staticRenderFns } from "./addSpecialMaterial.vue?vue&type=template&id=9c98ccfc&scoped=true"
import script from "./addSpecialMaterial.vue?vue&type=script&lang=js"
export * from "./addSpecialMaterial.vue?vue&type=script&lang=js"
import style0 from "./addSpecialMaterial.vue?vue&type=style&index=0&id=9c98ccfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c98ccfc",
  null
  
)

export default component.exports